import { h, Fragment } from "preact";

/**
 * The "Placement" grid (step 4). Renders one cell per placement from
 * `monogram.monogramPlacement` as a radio group; the selected placement is
 * highlighted. The selected style's disclaimer, if any, sits above the grid.
 */
export default function MonogramPlacementSelector({
  placements,
  selectedId,
  onSelect,
  sizeLabel,
  disclaimer,
}) {
  const columns = Math.min(placements.length, 3);

  return (
    <Fragment>
      {disclaimer && (
        <p className="monogram-placement-selector__disclaimer">
          {disclaimer}
        </p>
      )}
      <div
        className="monogram-placement-selector"
        role="radiogroup"
        data-columns={columns}
      >
        {placements.map((placement) => {
          const url = placement.image?.image?.url;
          const selected = placement.id === selectedId;
          return (
            <button
              key={placement.id}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`monogram-placement-selector__item ${
                selected ? "monogram-placement-selector__item--selected" : ""
              }`}
              onClick={() => onSelect(placement.id)}
            >
              <span className="monogram-placement-selector__image">
                {url && (
                  <img
                    src={window.getSizedImageUrl(url, "256x")}
                    alt={
                      placement.image?.image?.altText || placement.position || ""
                    }
                    loading="lazy"
                  />
                )}
              </span>
              <span className="monogram-placement-selector__details caption-1">
                <span className="monogram-placement-selector__size">
                  {sizeLabel}: {placement.size}
                </span>
                <span className="monogram-placement-selector__position">
                  {placement.position}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </Fragment>
  );
}
